import Module from '../../utils/modules/Module';

export default class ErrorPageModule extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = this.options.element;
    this.onResize = this.onResize.bind(this);
    this.init();
  }

  init() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  onResize() {
    if (document.documentElement.clientWidth < 768) {
      this.DOMEl.style.backgroundImage = 'url(' + this.DOMEl.dataset.bgmobile + ')';
    } else {
      this.DOMEl.style.backgroundImage = 'url(' + this.DOMEl.dataset.bg + ')';
    }
  }

}
